import { Link } from "react-router-dom";
import { Clock, ArrowLeft } from "lucide-react";
import { PublicHeader } from "../components/PublicHeader";
import { SiteFooter } from "../components/SiteFooter";

export default function ShortlistUnavailable() {
  return (
    <div className="min-h-screen bg-[#f5f3ee]">
      <PublicHeader hideCandidateCta />
      <main className="mx-auto max-w-2xl px-6 pb-24 pt-36 text-center" data-testid="shortlist-unavailable">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#0d2f4d] text-[#C1CC24]">
          <Clock size={30} />
        </span>
        <h1 className="mt-8 font-heading text-3xl font-bold tracking-tight text-[#0d2f4d] sm:text-4xl">
          The Shortlist is taking a short break
        </h1>
        <p className="mt-4 text-base text-[#51637a] leading-relaxed">
          Our candidate discovery board is temporarily offline while we make some improvements.
          It'll be back shortly — thanks for your patience.
        </p>
        <Link to="/" data-testid="unavailable-home-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0d2f4d] px-8 py-4 text-sm font-semibold text-white hover:bg-[#1c4d78] transition-colors">
          <ArrowLeft size={16} /> Back to home
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}
